package com.parmartechnologies.storage.table.business

import com.parmartechnologies.core.feature.business.model.Business
import com.parmartechnologies.storage.collection.DatabaseCollection
import com.parmartechnologies.storage.table.DatabaseTable

class BusinessDatabaseTable : DatabaseTable() {
    fun insert(item: Business?, callBack: () -> Unit = {}) {
        item.let { DatabaseCollection().insert(item!!, Business.serializer())}
        callBack()
    }

    fun insert(items: List<Business>?, callBack: () -> Unit) {
        items?.forEach { item ->
            insert(item) {}
        }
        callBack()
    }
}